import { useEffect } from "react";

export const useLoadAdsense = (enabled) => {
  useEffect(() => {
    console.log("enabled ::", enabled);

    if (!enabled) {
      // window.adsbygoogle = { push: () => {} };

      /* document.querySelectorAll("ins.adsbygoogle").forEach((ad) => {
        ad.style.display = "none";
        ad.remove();
      }); */

      return;
    }

    /* const script = document.createElement("script");
    script.async = true;
    script.src =
      "https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-8759251703965355";
    script.setAttribute("crossorigin", "anonymous");
    script.setAttribute("data-adsense-loaded", "true");

    document.head.appendChild(script);

    return () => {
      window.adsbygoogle = { push: () => {} };
    }; */
  }, [enabled]);
};
